import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  private generatedCoupons: Set<string>;

  constructor(private toast : ToastrService) {
    this.generatedCoupons = new Set();
  }

  showToast(title : string, message: string){
    this.toast.show(title, message);
  }

  showError(title : string, message: string){
    this.toast.error(title, message);
  }

  getCouponCodes(existingCouponList: any, count: number) : any {
    // Add Existing Codes In Set
    for (let i = 0; i < existingCouponList.length; i++) {
      this.generatedCoupons.add(existingCouponList[i].code);
    }

    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    // Generate count number of coupons
    var couponList = [];
    for (let j = 0; j < count; j++) {
      let coupon = "";

      // Generate random string of the specified length
      for (let k = 0; k < 10; k++) {
        coupon += characters.charAt(Math.floor(Math.random() * characters.length));
      }

      // Check if the coupon already exists, regenerate if it does
      while (this.generatedCoupons.has(coupon)) {
        coupon = '';
        for (let l = 0; l < 10; l++) {
          coupon += characters.charAt(Math.floor(Math.random() * characters.length));
        }
      }
      // Add the new coupon to the set of generated & new coupons
      this.generatedCoupons.add(coupon);
      couponList.push(coupon);
    }
    return couponList;
  }

  getTimeIntervalFromSeconds(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const sec = seconds % 60;
    return `${hours}:${minutes.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  }

  formatDownloadCount(count: number): string {
    if (count >= 1_000_000_000) {
      return (count / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B+';
    } else if (count >= 1_000_000) {
      return (count / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M+';
    } else if (count >= 1_000) {
      return (count / 1_000).toFixed(1).replace(/\.0$/, '') + 'K+';
    } else {
      return count.toString();
    }
  }

  getFormatedDateTime(dateString: string): string {
    const date = new Date(dateString);
  
    // Extract day, month, year
    const day = date.getUTCDate();
    const month = date.toLocaleString("en-US", { month: "short", timeZone: "UTC" });
    const year = date.getUTCFullYear();
  
    // Extract hours, minutes, and AM/PM
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
  
    // Convert to 12-hour format
    hours = hours % 12 || 12;
  
    // Add ordinal suffix to day
    const suffix = this.getDaySuffix(day);
  
    return `${day}${suffix} ${month}, ${year} at ${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
  }
  
  // Function to get ordinal suffix (st, nd, rd, th)
  getDaySuffix(day: number): string {
    if (day >= 11 && day <= 13) return "th"; // Special case for 11, 12, 13
    switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  }

}
